// 登录页面
export const LOGIN_URL = process.env.VUE_APP_LOGIN_URL
//登录页面回调地址
export const LOGIN_URL_BACK = process.env.VUE_APP_LOGIN_URL_BACK
